// extracted by mini-css-extract-plugin
export default {"option":"styles-module__option__src-labstep-web-grid-NewIndex-components-ToggleColumnOption-_ribqd"};